import React, { useEffect } from 'react';
import DeleteModal from '../settings/delete-modal';
import { useDeleteActivity } from './use-delete-activity';
import { ITripActivity } from '../../../Models/trips/trip-activity.model';

type Props = {
  show: boolean;
  handleClose: () => void;
  activity: ITripActivity | null;
  onSuccess?: () => void;
};

const DeleteActivityModal = ({
  show,
  handleClose,
  activity,
  onSuccess
}: Props) => {
  const {
    deleteActivity,
    isDeleting,
    error,
    resetError,
    activityTitle,
    canDelete
  } = useDeleteActivity(activity, () => {
    onSuccess?.();
    handleClose();
  });

  // Reset error when modal opens
  useEffect(() => {
    if (show) {
      resetError();
    }
  }, [show, resetError]);

  const handleDelete = async () => {
    if (!canDelete || isDeleting) {
      return;
    }

    const success = await deleteActivity();
    if (success) {
      // Modal will be closed by the onSuccess callback in useDeleteActivity
    }
    // If deletion fails, the error will be handled by the hook
    // and the modal stays open to show the error
  };

  const handleModalClose = () => {
    if (!isDeleting) {
      resetError();
      handleClose();
    }
  };

  // Create a custom title for the delete modal
  const deleteTitle = `Delete Activity: ${activityTitle}`;

  return (
    <DeleteModal
      show={show}
      handleClose={handleModalClose}
      handleDelete={handleDelete}
      title={deleteTitle}
    >
      {error && (
        <div
          className='alert alert-danger alert-dismissible mb-0'
          role='alert'
        >
          <strong>Error:</strong> {error}
          <button
            type='button'
            className='btn-close'
            aria-label='Close'
            onClick={resetError}
          />
        </div>
      )}
    </DeleteModal>
  );
};

export default DeleteActivityModal;
